import IconProps, { StyledG } from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function CollapseIcon({ color = '#000000' }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
			<StyledG stroke={color} strokeWidth={2} color="none" fill="none">
				<path d="M11 8 L17 14 L11 20" />
			</StyledG>
		</svg>
	);
}

export default CollapseIcon;
